import type { PageRect } from './layoutTypes';

export type ResizeHandleId =
  | 'nw'
  | 'n'
  | 'ne'
  | 'w'
  | 'e'
  | 'sw'
  | 's'
  | 'se';

export const RESIZE_HANDLES: readonly ResizeHandleId[] = [
  'nw',
  'n',
  'ne',
  'w',
  'e',
  'sw',
  's',
  'se',
];

export function rectsIntersect(a: PageRect, b: PageRect): boolean {
  return (
    a.x < b.x + b.width &&
    a.x + a.width > b.x &&
    a.y < b.y + b.height &&
    a.y + a.height > b.y
  );
}

export function pointInRect(x: number, y: number, rect: PageRect): boolean {
  return x >= rect.x && y >= rect.y && x <= rect.x + rect.width && y <= rect.y + rect.height;
}

export function translateRect(rect: PageRect, dx: number, dy: number): PageRect {
  return { ...rect, x: rect.x + dx, y: rect.y + dy };
}

export function clampRectToPage(
  rect: PageRect,
  pageWidthMm: number,
  pageHeightMm: number,
): PageRect {
  const width = Math.min(Math.max(rect.width, 8), pageWidthMm);
  const height = Math.min(Math.max(rect.height, 8), pageHeightMm);
  const x = Math.min(Math.max(rect.x, 0), Math.max(0, pageWidthMm - width));
  const y = Math.min(Math.max(rect.y, 0), Math.max(0, pageHeightMm - height));
  return { x, y, width, height };
}

export function resizeRect(
  rect: PageRect,
  handle: ResizeHandleId,
  pointerMm: { x: number; y: number },
): PageRect {
  let { x, y, width, height } = rect;
  const right = x + width;
  const bottom = y + height;
  const min = 8;

  if (handle.includes('w')) {
    const nextX = Math.min(pointerMm.x, right - min);
    width = right - nextX;
    x = nextX;
  }
  if (handle.includes('e')) {
    width = Math.max(min, pointerMm.x - x);
  }
  if (handle.includes('n')) {
    const nextY = Math.min(pointerMm.y, bottom - min);
    height = bottom - nextY;
    y = nextY;
  }
  if (handle.includes('s')) {
    height = Math.max(min, pointerMm.y - y);
  }
  return { x, y, width, height };
}
